module.exports = __webpack_public_path__ + "img/xb_icon01.18ad099d.png";